import { AllowedCountries } from "../../components/custom-phone-input";

export const countries = [
  { value: "Afghanistan", code: "af" },
  { value: "Albania", code: "al" },
  { value: "Algeria", code: "dz" },
  { value: "Andorra", code: "ad" },
  { value: "Angola", code: "ao" },
  { value: "Argentina", code: "ar" },
  { value: "Armenia", code: "am" },
  { value: "Australia", code: "au" },
  { value: "Austria", code: "at" },
  { value: "Azerbaijan", code: "az" },
  { value: "Bahamas", code: "bs" },
  { value: "Bahrain", code: "bh" },
  { value: "Bangladesh", code: "bd" },
  { value: "Barbados", code: "bb" },
  { value: "Belarus", code: "by" },
  { value: "Belgium", code: "be" },
  { value: "Belize", code: "bz" },
  { value: "Benin", code: "bj" },
  { value: "Bhutan", code: "bt" },
  { value: "Bolivia", code: "bo" },
  { value: "Bosnia and Herzegovina", code: "ba" },
  { value: "Botswana", code: "bw" },
  { value: "Brazil", code: "br" },
  { value: "Brunei", code: "bn" },
  { value: "Bulgaria", code: "bg" },
  { value: "Burkina Faso", code: "bf" },
  { value: "Burundi", code: "bi" },
  { value: "Cambodia", code: "kh" },
  { value: "Cameroon", code: "cm" },
  { value: "Canada", code: "ca" },
  { value: "Cape Verde", code: "cv" },
  { value: "Central African Republic", code: "cf" },
  { value: "Chad", code: "td" },
  { value: "Chile", code: "cl" },
  { value: "China", code: "cn" },
  { value: "Colombia", code: "co" },
  { value: "Comoros", code: "km" },
  { value: "Congo", code: "cg" },
  { value: "Costa Rica", code: "cr" },
  { value: "Croatia", code: "hr" },
  { value: "Cuba", code: "cu" },
  { value: "Cyprus", code: "cy" },
  { value: "Czech Republic", code: "cz" },
  { value: "Denmark", code: "dk" },
  { value: "Djibouti", code: "dj" },
  { value: "Dominica", code: "dm" },
  { value: "Dominican Republic", code: "do" },
  { value: "Ecuador", code: "ec" },
  { value: "Egypt", code: "eg" },
  { value: "El Salvador", code: "sv" },
  { value: "Equatorial Guinea", code: "gq" },
  { value: "Eritrea", code: "er" },
  { value: "Estonia", code: "ee" },
  { value: "Eswatini", code: "sz" },
  { value: "Ethiopia", code: "et" },
  { value: "Fiji", code: "fj" },
  { value: "Finland", code: "fi" },
  { value: "France", code: "fr" },
  { value: "Gabon", code: "ga" },
  { value: "Gambia", code: "gm" },
  { value: "Georgia", code: "ge" },
  { value: "Germany", code: "de" },
  { value: "Ghana", code: "gh" },
  { value: "Greece", code: "gr" },
  { value: "Grenada", code: "gd" },
  { value: "Guatemala", code: "gt" },
  { value: "Guinea", code: "gn" },
  { value: "Guinea-Bissau", code: "gw" },
  { value: "Guyana", code: "gy" },
  { value: "Haiti", code: "ht" },
  { value: "Honduras", code: "hn" },
  { value: "Hungary", code: "hu" },
  { value: "Iceland", code: "is" },
  { value: "India", code: "in" },
  { value: "Indonesia", code: "id" },
  { value: "Iran", code: "ir" },
  { value: "Iraq", code: "iq" },
  { value: "Ireland", code: "ie" },
  { value: "Israel", code: "il" },
  { value: "Italy", code: "it" },
  { value: "Jamaica", code: "jm" },
  { value: "Japan", code: "jp" },
  { value: "Jordan", code: "jo" },
  { value: "Kazakhstan", code: "kz" },
  { value: "Kenya", code: "ke" },
  { value: "Kiribati", code: "ki" },
  { value: "Kuwait", code: "kw" },
  { value: "Kyrgyzstan", code: "kg" },
  { value: "Laos", code: "la" },
  { value: "Latvia", code: "lv" },
  { value: "Lebanon", code: "lb" },
  { value: "Lesotho", code: "ls" },
  { value: "Liberia", code: "lr" },
  { value: "Libya", code: "ly" },
  { value: "Liechtenstein", code: "li" },
  { value: "Lithuania", code: "lt" },
  { value: "Luxembourg", code: "lu" },
  { value: "Madagascar", code: "mg" },
  { value: "Malawi", code: "mw" },
  { value: "Malaysia", code: "my" },
  { value: "Maldives", code: "mv" },
  { value: "Mali", code: "ml" },
  { value: "Malta", code: "mt" },
  { value: "Mauritania", code: "mr" },
  { value: "Mauritius", code: "mu" },
  { value: "Mexico", code: "mx" },
  { value: "Moldova", code: "md" },
  { value: "Monaco", code: "mc" },
  { value: "Mongolia", code: "mn" },
  { value: "Montenegro", code: "me" },
  { value: "Morocco", code: "ma" },
  { value: "Mozambique", code: "mz" },
  { value: "Myanmar", code: "mm" },
  { value: "Namibia", code: "na" },
  { value: "Nepal", code: "np" },
  { value: "Netherlands", code: "nl" },
  { value: "New Zealand", code: "nz" },
  { value: "Nicaragua", code: "ni" },
  { value: "Niger", code: "ne" },
  { value: "Nigeria", code: "ng" },
  { value: "North Korea", code: "kp" },
  { value: "North Macedonia", code: "mk" },
  { value: "Norway", code: "no" },
  { value: "Oman", code: "om" },
  { value: "Pakistan", code: "pk" },
  { value: "Palau", code: "pw" },
  { value: "Palestine", code: "ps" },
  { value: "Panama", code: "pa" },
  { value: "Papua New Guinea", code: "pg" },
  { value: "Paraguay", code: "py" },
  { value: "Peru", code: "pe" },
  { value: "Philippines", code: "ph" },
  { value: "Poland", code: "pl" },
  { value: "Portugal", code: "pt" },
  { value: "Qatar", code: "qa" },
  { value: "Romania", code: "ro" },
  { value: "Russia", code: "ru" },
  { value: "Rwanda", code: "rw" },
  { value: "Saint Kitts and Nevis", code: "kn" },
  { value: "Saint Lucia", code: "lc" },
  { value: "Saint Vincent and the Grenadines", code: "vc" },
  { value: "Samoa", code: "ws" },
  { value: "San Marino", code: "sm" },
  { value: "Saudi Arabia", code: "sa" },
  { value: "Senegal", code: "sn" },
  { value: "Serbia", code: "rs" },
  { value: "Seychelles", code: "sc" },
  { value: "Sierra Leone", code: "sl" },
  { value: "Singapore", code: "sg" },
  { value: "Slovakia", code: "sk" },
  { value: "Slovenia", code: "si" },
  { value: "Solomon Islands", code: "sb" },
  { value: "Somalia", code: "so" },
  { value: "South Africa", code: "za" },
  { value: "South Korea", code: "kr" },
  { value: "South Sudan", code: "ss" },
  { value: "Spain", code: "es" },
  { value: "Sri Lanka", code: "lk" },
  { value: "Sudan", code: "sd" },
  { value: "Suriname", code: "sr" },
  { value: "Sweden", code: "se" },
  { value: "Switzerland", code: "ch" },
  { value: "Syria", code: "sy" },
  { value: "Taiwan", code: "tw" },
  { value: "Tajikistan", code: "tj" },
  { value: "Tanzania", code: "tz" },
  { value: "Thailand", code: "th" },
  { value: "Togo", code: "tg" },
  { value: "Tonga", code: "to" },
  { value: "Trinidad and Tobago", code: "tt" },
  { value: "Tunisia", code: "tn" },
  { value: "Turkey", code: "tr" },
  { value: "Turkmenistan", code: "tm" },
  { value: "Tuvalu", code: "tv" },
  { value: "Uganda", code: "ug" },
  { value: "Ukraine", code: "ua" },
  { value: "United Arab Emirates", code: "ae" },
  { value: "United Kingdom", code: "gb" },
  { value: "United States", code: "us" },
  { value: "Uruguay", code: "uy" },
  { value: "Uzbekistan", code: "uz" },
  { value: "Vanuatu", code: "vu" },
  { value: "Vatican City", code: "va" },
  { value: "Venezuela", code: "ve" },
  { value: "Vietnam", code: "vn" },
  { value: "Yemen", code: "ye" },
  { value: "Zambia", code: "zm" },
  { value: "Zimbabwe", code: "zw" },
];

export const ALLOWED_COUNTRIES: AllowedCountries = {
  ng: {
    name: "Nigeria",
    code: "ng",
    dialCode: "+234",
    localLength: 10,
    pattern: /^[0-9]{10}$/,
    format: "XXX XXX XXXX",
    example: "801 234 5678",
    flag: "🇳🇬",
  },
  in: {
    name: "India",
    code: "in",
    dialCode: "+91",
    localLength: 10,
    pattern: /^[0-9]{10}$/,
    format: "XXXXX XXXXX",
    example: "98765 43210",
    flag: "🇮🇳",
  },
};